var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "aggregator-icons d-flex" },
    [
      _vm._l(_vm.limitedAggregators, function (prov, index) {
        return _c("div", {
          key: index,
          staticClass: "icon",
          domProps: { innerHTML: _vm._s(prov.icon) },
        })
      }),
      _vm._v(" "),
      _vm.hiddenCount > 0
        ? _c("div", { staticClass: "icon more-count" }, [
            _vm._v("\n        +" + _vm._s(_vm.hiddenCount) + "\n    "),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }